import { formatPhoneNumber } from '@/lib/phoneNumber';
import type { User } from '@/types/domain/user';

type UserIdentity = Pick<User, 'email' | 'name' | 'phoneNumber' | 'socialNumber'>;

function normalizeLabel(value?: string | null) {
  const normalizedValue = value?.trim();

  return normalizedValue ? normalizedValue : null;
}

export function getUserDisplayName(user?: UserIdentity | null) {
  const name = normalizeLabel(user?.name);

  if (name) {
    return name;
  }

  const phoneNumber = normalizeLabel(formatPhoneNumber(user?.phoneNumber));

  if (phoneNumber) {
    return phoneNumber;
  }

  const email = normalizeLabel(user?.email);

  if (email) {
    return email;
  }

  const socialNumber = normalizeLabel(user?.socialNumber);

  if (socialNumber) {
    return socialNumber;
  }

  return 'Minha conta';
}

export function getUserShortName(user?: UserIdentity | null) {
  const name = normalizeLabel(user?.name);

  if (!name) {
    return getUserDisplayName(user);
  }

  return name.split(/\s+/)[0] || name;
}

export function getUserInitials(user?: UserIdentity | null) {
  const name = normalizeLabel(user?.name);

  if (!name) {
    return 'VT';
  }

  const [firstName = '', lastName = ''] = name.split(/\s+/);
  const initials = `${firstName.charAt(0)}${lastName.charAt(0)}`.trim();

  return initials.toUpperCase() || firstName.slice(0, 2).toUpperCase() || 'VT';
}
